var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14985 22.9935H17.4817C19.5609 22.9935 20.6315 21.8534 20.6315 19.6667V10.5706H13.3807C12.1672 10.5706 11.5773 9.95252 11.5773 8.6794V1H7.14985C5.08028 1 4 2.14838 4 4.335V19.6667C4 21.8617 5.07232 22.9935 7.14985 22.9935ZM13.553 9.08523H20.5256C20.4744 8.63023 20.1529 8.19087 19.649 7.65274L14.3538 2.02015C13.8664 1.50317 13.4374 1.16826 12.9951 1.10445V8.50911C12.9951 8.89319 13.1784 9.08523 13.553 9.08523Z",
    fill: "#298CFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3161 12.4878C12.7582 12.4878 13.1298 12.8385 13.1298 13.2933V16.6635L13.0497 18.1838L13.7876 17.3951L14.579 16.542C14.7235 16.3887 14.9271 16.2837 15.1306 16.2837C15.549 16.2837 15.8634 16.5993 15.8634 17.022C15.8634 17.2675 15.7743 17.453 15.6044 17.6088L12.9323 20.181C12.7191 20.3821 12.5361 20.4734 12.3161 20.4734C12.0961 20.4734 11.913 20.3821 11.6998 20.181L9.02772 17.6088C8.85955 17.453 8.77051 17.2675 8.77051 17.022C8.77051 16.5993 9.07525 16.2837 9.50162 16.2837C9.69715 16.2837 9.90684 16.3887 10.0531 16.542L10.848 17.3951L11.5825 18.1838L11.5103 16.6635V13.2933C11.5103 12.8385 11.8758 12.4878 12.3161 12.4878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.0f4ab87df88ebf27e3b4897925453999.svg";
export { ForwardRef as ReactComponent };